import React from "react";
import { BUSINESS_NAME, CALL_URL, CONTACT_ADDRESS, CONTACT_PHONE_DISPLAY } from "../config";

function Footer() {    
    const currentYear = new Date().getFullYear(); 

    return (
        <footer className="main-footer primary-bg">
            <div className="container">
                <div className="columns is-vcentered">
                    {/* Left Column: how to reach the business */}
                    <div className="column is-one-third has-text-left-tablet has-text-centered-mobile has-text-white">
                        <p>
                            <a href={CALL_URL} className="has-text-white">{CONTACT_PHONE_DISPLAY}</a>
                            <br />
                            {CONTACT_ADDRESS}
                        </p>
                    </div>

                    {/* Center Column: Copyright Text */}
                    <div className="column is-one-third has-text-centered has-text-white">
                        <p>&copy; {currentYear} {BUSINESS_NAME}. <br/> All rights reserved.</p>
                    </div>

                    {/* Right Column: Privacy Policy and Terms & Conditions */}
                    <div className="column is-one-third has-text-right">
                        <a href="/privacy-policy" className="has-text-white">Privacy Policy</a> &nbsp;|&nbsp;
                        <a href="/terms-and-conditions" className="has-text-white">Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
